import { formatMonto } from "@/utils.js";

export const PrivInsColumns = [
  {
    prop: "Name",
    label: "Nombre del dependiente",
    "min-width": 100
    //formatter: PerfilPerson
  },
  {
    prop: "relationship",
    label: "Parentezco",
    "min-width": 100
    //formatter: PerfilPerson
  },
  {
    prop: "Identification",
    label: "Cédula",
    "min-width": 100
    //formatter: PerfilPerson
  },
  {
    prop: "Amount",
    label: "Monto",
    "min-width": 100,
    formatter: (row) => formatMonto(row.Amount)
  }
];

export const PrivInsactions = [
  {
    label: "Editar dependiente",
    command: "edit_insurance",
    icon: "el-icon-edit"
  },
  {
    label: "Borrar dependiente",
    command: "delete_insurance",
    icon: "el-icon-delete"
  }
];
